import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VLayout,{staticClass:"pa-6",attrs:{"wrap":"","justify-center":""}},[_c(VFlex,{attrs:{"xs12":"","md12":""}},[_c(VCard,{staticClass:"mx-auto col-12",attrs:{"max-width":"1300","elevation":"2"}},[_c(VCardTitle,[_c(VListItem,[_c(VListItemIcon,[_c(VIcon,{attrs:{"size":"30","color":"blue darken-4 "}},[_vm._v("mdi-bank-check")])],1),_c(VListItemContent,[_c(VListItemTitle,{staticClass:"headline"},[_vm._v("Escala 0-2 años")])],1)],1)],1),_c(VCardText,[_c(VContainer,[_c(VRow,{staticClass:"text-center"},[_c(VCol,{attrs:{"cols":"3"}},[_c(VBtn,{on:{"click":function($event){return _vm.get_pdf()}}},[_vm._v("Graficos")])],1),_c(VCol,{attrs:{"cols":"3"}},[_c(VBtn,{on:{"click":function($event){_vm.graficar(
                    _vm.labels.titulo1,
                    _vm.labels.primero,
                    'grafico1',
                    _vm.data1,
                    _vm.puntos.primeraGr
                  );
                  _vm.graficar(
                    _vm.labels.titulo2,
                    _vm.labels.segundo,
                    'grafico2',
                    _vm.data2,
                    _vm.puntos.segundaGr
                  );}}},[_vm._v("GR")])],1),_c(VCol,{attrs:{"cols":"12"}},[_c('canvas',{attrs:{"id":"grafico1"}})]),_c(VCol,{attrs:{"cols":"12"}},[_c('canvas',{attrs:{"id":"grafico2"}})])],1)],1)],1)],1)],1),_c(VOverlay,{attrs:{"value":_vm.loader}},[_c('flower-spinner',{attrs:{"animation-duration":2500,"size":100,"color":"#0d47a1"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }